import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

import {
    BrowserRouter as Router
} from "react-router-dom";

import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import axios from 'axios';
import authReducer from './store/reducers/auth';
import clientsReducer from './store/reducers/clients';
import packagesReducer from './store/reducers/packages';
import subPackagesReducer from './store/reducers/subpackages';
import creditsReducer from './store/reducers/credits';
import addClientReducer from './store/reducers/addclient';
import clientReducer from './store/reducers/client';
import saveClientReducer from './store/reducers/saveclient';
import deleteClientReducer from './store/reducers/deleteclient';
import resellersReducer from './store/reducers/resellers';
import resellerReducer from './store/reducers/reseller';
import addResellerReducer from './store/reducers/addreseller';
import saveResellerReducer from './store/reducers/savereseller';
import dealersReducer from './store/reducers/dealers';
import dealerReducer from './store/reducers/dealer';
import addDealerReducer from './store/reducers/adddealer';
import saveDealerReducer from './store/reducers/savedealer';
import superResellersReducer from './store/reducers/sresellers';
import superResellerReducer from './store/reducers/sreseller';
import addSuperResellerReducer from './store/reducers/addsreseller';
import saveSuperResellerReducer from './store/reducers/savesreseller';
import getMessageReducer from './store/reducers/message';
import saveMessageReducer from './store/reducers/savemessage';
import snackbarReducer from './store/reducers/snackbar';
import clientInfoReducer from './store/reducers/clientinfo';
import transactionsReducer from './store/reducers/transactions';
import retrieveCreditsReducer from './store/reducers/retrievecredits';
import renewCreditsReducer from './store/reducers/renew';
import searchReducer from './store/reducers/search';
import macReducer from './store/reducers/mac';
import searchMacReducer from './store/reducers/searchmac';
import sendMessageReducer from './store/reducers/sendmessage';
import passwordReducer from './store/reducers/password';
import countResellersReducer from './store/reducers/cresellers';
import countDealersReducer from './store/reducers/cdealers';
import countAllClientsReducer from './store/reducers/callclients';
import countActiveClientsReducer from './store/reducers/cactiveclients';
import countExpiredClientsReducer from './store/reducers/cexpiredclients';
import countTrialsReducer from './store/reducers/ctrials';
import countMinistraReducer from './store/reducers/cministra';
import addTicketReducer from './store/reducers/addticket';
import ticketsReducer from './store/reducers/tickets';
import ticketReducer from './store/reducers/ticket';
import saveTicketReducer from './store/reducers/saveticket';
import ticketDetailsReducer from './store/reducers/ticketdetails';
import addTicketDetailReducer from './store/reducers/addticketdetail';
import countActiveTicketsReducer from './store/reducers/cactivetickets';
import totalStatsReducer from './store/reducers/totalstats';
import statsChartReducer from './store/reducers/statschart';
import tariffReducer from './store/reducers/tariff';
import resetClientReducer from './store/reducers/resetClient';
//import {deleteClient} from "./store/actions";
//import {saveClient} from "./store/actions";

axios.defaults.baseURL = 'https://app.titan4k.cc';
//axios.defaults.baseURL = 'http://localhost:3761';
//axios.defaults.baseURL = 'http://149.56.19.8:3600'; // c
//axios.defaults.baseURL = 'http://158.69.124.7:3700'; // c
//axios.defaults.baseURL = 'http://z13.tw';

const rootReducer = combineReducers({
    auth: authReducer,
    clients: clientsReducer,
    packages: packagesReducer,
    subPackages: subPackagesReducer,
    credits: creditsReducer,
    addClient: addClientReducer,
    clientReducer: clientReducer,
    saveClient: saveClientReducer,
    resetClient: resetClientReducer,
    deleteClientReducer: deleteClientReducer,
    resellers: resellersReducer,
    reseller: resellerReducer,
    addReseller: addResellerReducer,
    saveReseller: saveResellerReducer,
    dealers: dealersReducer,
    dealer: dealerReducer,
    addDealer: addDealerReducer,
    saveDealer: saveDealerReducer,
    superResellers: superResellersReducer,
    superReseller: superResellerReducer,
    addSuperReseller: addSuperResellerReducer,
    saveSuperReseller: saveSuperResellerReducer,
    getMessage: getMessageReducer,
    saveMessage: saveMessageReducer,
    snackbar: snackbarReducer,
    clientInfo: clientInfoReducer,
    transactions: transactionsReducer,
    retrieveCredits: retrieveCreditsReducer,
    renewCredits: renewCreditsReducer,
    searchClients: searchReducer,
    macReducer: macReducer,
    passwordReducer: passwordReducer,
    searchMac: searchMacReducer,
    sendMessage: sendMessageReducer,
    countResellers: countResellersReducer,
    countDealers: countDealersReducer,
    countAllClients: countAllClientsReducer,
    countActiveClients: countActiveClientsReducer,
    countExpiredClients: countExpiredClientsReducer,
    countTrials: countTrialsReducer,
    countMinistra: countMinistraReducer,
    addTicket: addTicketReducer,
    tickets: ticketsReducer,
    ticket: ticketReducer,
    saveTicket: saveTicketReducer,
    ticketDetails: ticketDetailsReducer,
    addTicketDetail: addTicketDetailReducer,
    countActiveTickets: countActiveTicketsReducer,
    totalStats: totalStatsReducer,
    statsChart: statsChartReducer,
    tariff: tariffReducer
});

const logger = state => {
    return next => {
        return action => {
            const result = next(action);
            return result;

        }
    }
};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(rootReducer, composeEnhancers(applyMiddleware(logger, thunk)));

ReactDOM.render(
    <Provider store={store}>
        <Router>
            <App />
        </Router>
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
